module.exports = __webpack_public_path__ + "static/Touchless_MonthTwo-38-9fc871b9d194be05f06c99ad68607915.jpg";